export enum BackendApiType {
  XVI = 'xvi',
  DM = 'dm',
  PORTAL = 'portal',
  XEA = 'xea',
}
